import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'

import Lightbox from './react-image-lightbox/react-image-lightbox'

import {closeZoomModal, imageCarouselControl} from '../../../actions/productDetailPage'
import * as pdp from '../../../store/productDetailPage'

const MobileProductZoom = ({closeModal, currIndex, carouselControl, images, modalIsOpen}) =>
  modalIsOpen && (
    <Lightbox
      animationDisabled
      mainSrc={`${images[currIndex].url}`}
      nextSrc={`${images[(currIndex + 1) % images.length].url}`}
      prevSrc={`${images[(currIndex + (images.length - 1)) % images.length].url}`}
      onCloseRequest={() => closeModal()}
      onMoveNextRequest={() => carouselControl('next')}
      onMovePrevRequest={() => carouselControl('previous')}
    />
  )

MobileProductZoom.propTypes = {
  currIndex: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
  carouselControl: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => ({
  currIndex: pdp.currentZoomImageIndex(state),
  images: pdp.productAndModelImages(state),
  modalIsOpen: pdp.zoomModalIsOpen(state),
})

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => dispatch(closeZoomModal()),
  carouselControl: (direction) => dispatch(imageCarouselControl(direction)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MobileProductZoom)
